import { env } from "@/env";

/**
 * Clients (ie. browsers) can use only the public URL which requires GCP authentication for IAP.
 */
export function getPayloadUrlForClientRequests() {
  return env.NEXT_PUBLIC_CMS_URL;
}
